export default function GestureTarget(type, index = -1) {
  return { type, index }
}
